<template>
  <div class="plist">
    <div class="plist__head">
      <div>Broj</div>
      <div>Prijem</div>
      <div>Oštećeni</div>
      <div>Vrsta</div>
      <div>Obaveza</div>
      <div>Zadužio</div>
      <div>Nosioc</div>
      <div>Faza</div>
    </div>

    <div class="plist__body">
      <template v-if="loading">
        <div v-for="n in 8" :key="'sk' + n" class="plist__row plist__row--skeleton">
          <div v-for="c in 8" :key="'skc' + c" class="skeleton"></div>
        </div>
      </template>

      <div v-else-if="!tableData.length" class="plist__empty">
        <div class="plist__empty-title">Nema predmeta za ove filtere</div>
        <div class="plist__empty-sub">Poništite filtere ili promijenite pretragu</div>
      </div>

      <div
        v-else
        v-for="row in tableData"
        :key="row.id"
        :class="['plist__row', { 'is-selected': row.id === selectedId }]"
        @click="select(row)"
        @dblclick="openPredmet(row.id)"
      >
        <div class="plist__broj">{{ row.broj }}</div>
        <div class="plist__muted">{{ shortDate(row.datum_prijema) }}</div>
        <div class="plist__truncate" :title="ostecenoNames(row)">{{ ostecenoNames(row) || "—" }}</div>
        <div class="plist__muted plist__truncate">{{ vrstaName(row) }}</div>
        <div class="plist__muted plist__truncate" :title="obavezaNames(row)">{{ obavezaNames(row) || "—" }}</div>
        <div class="plist__muted plist__truncate">{{ ownerName(row) }}</div>
        <div class="plist__truncate">
          <span v-if="nosiocOf(row) && nosiocOf(row).advokat" class="plist__advokat" :title="nosiocOf(row).naziv">
            {{ nosiocOf(row).naziv }}
          </span>
          <span v-else class="plist__muted">{{ nosiocOf(row) ? nosiocOf(row).naziv : "—" }}</span>
        </div>
        <div><StatusTag :value="row.status" /></div>
      </div>
    </div>

    <div class="plist__foot">
      <div class="plist__total">
        {{ pager.totalItems }} predmeta<template v-if="totalPages"> · strana {{ pager.page }} od {{ totalPages }}</template>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="pager.pageSize"
        :current-page="pager.page"
        :total="pager.totalItems"
        @current-change="pageUpdate"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import API from "@/services/api/api";
import StatusTag from "@/components/StatusTag";
import { loadNosioci } from "@/models/nosioc";
import { ALL_PHASES } from "@/models/status";

export default {
  name: "PredmetList",
  components: { StatusTag },
  props: {
    filter: {
      type: Object,
      default: () => {},
    },
    search: {
      type: String,
      default: "",
    },
    numonlymode: {
      type: Boolean,
      default: false,
    },
    fobv: {
      type: Number,
      default: -1,
    },
    fsar: {
      type: Number,
      default: -1,
    },
    fnos: {
      type: Number,
      default: -1,
    },
    waitload: {
      type: Boolean,
      default: true,
    },
    selectedId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      tableData: [],
      kontaktData: {},
      obavezaData: {},
      vrstaOsiguranjaData: {},
      searchQ: "",
      waitLoadFlag: true,
      numOnly: false,
      loading: false,
      oldfilter: {
        op: "",
        val: -1,
      },
      obaveza: -1,
      saradnik: -1,
      nosioc: -1,
      nosioci: [],
      skipFirstSearch: true,
      pager: {
        totalItems: 0,
        pageSize: 25,
        page: 1,
      },
    };
  },
  created() {
    loadNosioci()
      .then((list) => (this.nosioci = list))
      .catch((e) => console.log(e));
  },
  computed: {
    totalPages() {
      return Math.ceil(this.pager.totalItems / this.pager.pageSize) || 0;
    },
  },
  watch: {
    filter: {
      handler(e) {
        const st = (e && e.status) || {};
        if (st.op != this.oldfilter.op || st.val != this.oldfilter.val) {
          this.oldfilter = { op: st.op, val: st.val };
          this.loadPage(1, this.pager.pageSize);
        }
      },
      deep: true,
      immediate: true,
    },
    search: {
      handler(e) {
        this.searchQ = e;
        if (e == "" && this.skipFirstSearch) {
          this.skipFirstSearch = false;
          return;
        }

        this.loadPage(1, this.pager.pageSize);
      },
      deep: true,
      immediate: true,
    },
    numonlymode: {
      handler(e) {
        this.numOnly = e || false;
        if (this.numOnly == false && this.skipFirstSearch) {
          this.skipFirstSearch = false;
          return;
        }

        this.loadPage(1, this.pager.pageSize);
      },
      deep: true,
      immediate: true,
    },
    fobv: {
      handler(e) {
        if (e == "") {
          this.obaveza = -1;
        } else {
          this.obaveza = e;
        }

        if (this.obaveza == -1 && this.skipFirstSearch) {
          this.skipFirstSearch = false;
          return;
        }

        this.loadPage(1, this.pager.pageSize);
      },
      deep: true,
      immediate: true,
    },
    fnos: {
      handler(e) {
        this.nosioc = e === "" || e === null || e === undefined ? -1 : e;

        if (this.nosioc == -1 && this.skipFirstSearch) {
          this.skipFirstSearch = false;
          return;
        }

        this.loadPage(1, this.pager.pageSize);
      },
      deep: true,
      immediate: true,
    },
    fsar: {
      handler(e) {
        this.saradnik = e === "" ? -1 : e;

        if (this.saradnik == -1 && this.skipFirstSearch) {
          this.skipFirstSearch = false;
          return;
        }

        this.loadPage(1, this.pager.pageSize);
      },
      deep: true,
      immediate: true,
    },
    waitload: {
      handler(e) {
        this.waitLoadFlag = e;

        this.loadPage(1, this.pager.pageSize);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    select(row) {
      this.$emit("select", row);
    },
    openPredmet: function (id) {
      this.$router.push("/predmet/view/" + id.toString());
    },
    shortDate: function (date) {
      if (date == undefined) {
        return "";
      }
      return moment(date).format("DD.MM.YY");
    },
    getKontakt: function (id) {
      if (id in this.kontaktData) {
        return this.kontaktData[id];
      } else {
        return { ime: "", prezime: "" };
      }
    },
    getObaveza: function (id) {
      return this.obavezaData[id];
    },
    getVrstaOsiguranja: function (id) {
      return this.vrstaOsiguranjaData[id];
    },
    ostecenoNames: function (row) {
      return (row.osteceni_ids || [])
        .map((o) => this.getKontakt(o.oid))
        .map((k) => `${k.ime} ${k.prezime}`.trim())
        .filter(Boolean)
        .join(", ");
    },
    obavezaNames: function (row) {
      return (row.obaveza || [])
        .map((o) => this.getObaveza(o))
        .filter(Boolean)
        .map((o) => o.naziv)
        .join(", ");
    },
    nosiocOf(row) {
      return this.nosioci.find((n) => n.id === row.nosioc_id) || null;
    },
    vrstaName: function (row) {
      const v = this.getVrstaOsiguranja(row.vrsta_osiguranja_id);
      return v ? v.naziv : "—";
    },
    ownerName: function (row) {
      return row.owner ? `${row.owner.first_name} ${row.owner.last_name}` : "—";
    },
    pageUpdate: function (page) {
      this.loadPage(page, this.pager.pageSize);
    },
    loadPage: function (page, pageSize) {
      if (this.waitLoadFlag) {
        return;
      }
      // Copy: this used to mutate the parent's filter object in place.
      let fltr = { ...this.filter };
      if (fltr["status"] && fltr["status"].val === ALL_PHASES) {
        // No status constraint at all — open and closed cases together.
        delete fltr["status"];
      } else if (fltr["status"] && fltr["status"].val == -1) {
        fltr["status"] = { op: "lt", val: 10 };
      }
      if (this.searchQ != "") {
        fltr = {
          ...fltr,
          q: { val: this.searchQ },
        };
      }
      if (this.numOnly) {
        fltr = {
          ...fltr,
          fopts: { val: "num_only" },
        };
      }
      if (this.obaveza > 0) {
        fltr = {
          ...fltr,
          fobv: { val: this.obaveza },
        };
      }
      if (this.nosioc > 0) {
        fltr = {
          ...fltr,
          nosioc_id: { op: "eq", val: this.nosioc },
        };
      }
      if (this.saradnik > 0) {
        // saradnik_id is a column on predmet, so the generic filter handles
        // it; the op is required because other filters send one and the API
        // reads them from the same map.
        fltr = {
          ...fltr,
          saradnik_id: { op: "eq", val: this.saradnik },
        };
      }
      this.loading = true;
      API.Predmeti.list({ page, pageSize }, fltr, {
        datum_prijema: "DESC",
      })
        .then(async (data) => {
          let d = data.data.data;
          let p = data.data.data.paginator;
          this.pager.totalItems = p.total_results;
          this.pager.page = page;
          this.$emit("count", p.total_results);

          let kontaktIds = new Set();
          let obavezaIds = new Set();
          let vrstaOsiguranjaIds = new Set();

          d.results.forEach((predmet) => {
            predmet.osteceni_ids.forEach((o) => {
              kontaktIds.add(o.oid);
              kontaktIds.add(o.pid);
            });

            predmet.obaveza.forEach((o) => {
              obavezaIds.add(o);
            });
            vrstaOsiguranjaIds.add(predmet.vrsta_osiguranja_id);
          });
          await this.loadKontakts(Array.from(kontaktIds));
          await this.loadObaveza(Array.from(obavezaIds));
          await this.loadVrstaOsiguranja(Array.from(vrstaOsiguranjaIds));

          this.tableData = d.results;
        })
        .catch((err) => {
          console.log(err);
        })
        .then(() => {
          this.loading = false;
        });
    },
    loadKontakts: async function (ids) {
      if (!ids.length) return;
      return API.Kontakti.many(ids)
        .then((data) => {
          let d = data.data.data;
          d.results.forEach((o) => {
            this.$set(this.kontaktData, o.id, o);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadObaveza: async function (ids) {
      if (!ids.length) return;
      return API.Generic.many("obaveza", ids)
        .then((data) => {
          let d = data.data.data;
          d.results.forEach((o) => {
            this.$set(this.obavezaData, o.id, o);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadVrstaOsiguranja: async function (ids) {
      if (!ids.length) return;
      return API.Generic.many("vrsta_osiguranja", ids)
        .then((data) => {
          let d = data.data.data;
          d.results.forEach((o) => {
            this.$set(this.vrstaOsiguranjaData, o.id, o);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$cols: 96px 74px minmax(0, 1.4fr) 110px minmax(0, 1.2fr) 108px 140px 150px;

.plist {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-lg) 0 0 var(--r-lg);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.plist__head {
  display: grid;
  grid-template-columns: $cols;
  gap: 12px;
  padding: 8px 14px;
  border-bottom: 1px solid var(--line);
  background: var(--surface-alt);
  font-size: var(--fs-xs);
  font-weight: 600;
  color: var(--ink-3);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  flex-shrink: 0;
}

.plist__body {
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
}

.plist__row {
  display: grid;
  grid-template-columns: $cols;
  gap: 12px;
  align-items: center;
  padding: 0 14px;
  min-height: var(--row-h);
  border-bottom: 1px solid var(--line-soft);
  border-left: 3px solid transparent;
  font-size: var(--fs-md);
  color: var(--ink);
  cursor: pointer;
  user-select: none;

  &:hover {
    background: var(--surface-alt);
  }

  &.is-selected {
    background: var(--brand-tint);
    border-left-color: var(--brand);
  }
}

.plist__row--skeleton {
  cursor: default;

  &:hover {
    background: none;
  }
}

.plist__broj {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.plist__advokat {
  display: inline-block;
  max-width: 100%;
  padding: 1px 8px;
  border-radius: 999px;
  background: #e6f4f1;
  border: 1px solid #b5ddd6;
  color: #0f5e57;
  font-size: var(--fs-xs);
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.plist__muted {
  color: var(--ink-2);
}

.plist__truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.plist__empty {
  padding: 48px 20px;
  text-align: center;
}

.plist__empty-title {
  font-size: var(--fs-md);
  font-weight: 600;
  color: var(--ink-2);
}

.plist__empty-sub {
  font-size: var(--fs-sm);
  color: var(--ink-4);
  margin-top: 3px;
}

.plist__foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 14px;
  border-top: 1px solid var(--line);
  flex-shrink: 0;
}

.plist__total {
  font-size: var(--fs-sm);
  color: var(--ink-3);
  font-variant-numeric: tabular-nums;
}

.skeleton {
  height: 11px;
  border-radius: 4px;
  background: #eef2f7;
}
</style>
